import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EV = "on-qualify-required";
const FIELDS = [["first_name", "Nome referente"], ["last_name", "Cognome referente"], ["job_title", "Ruolo"], ["phone", "Telefono"], ["email", "Email"]];

export const isQualifyError = (e) => e?.response?.data?.detail?.code === "qualification_required";

// Opens the qualification dialog; resolves true once the customer is qualified.
export const qualifyThen = (e, opportunityId) => new Promise((resolve) => {
  window.dispatchEvent(new CustomEvent(EV, { detail: { gap: e.response.data.detail, opportunityId, resolve } }));
});

export const QualifyHost = () => {
  const [req, setReq] = useState(null);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const on = (ev) => {
      const { gap } = ev.detail;
      setF({ name: gap.company_name || "", ...Object.fromEntries(FIELDS.map(([k]) => [k, (gap.contact?.[k] || "").replace(/^-$/, "")])) });
      setReq(ev.detail);
    };
    window.addEventListener(EV, on);
    return () => window.removeEventListener(EV, on);
  }, []);
  const close = (ok) => { req?.resolve(ok); setReq(null); };
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/crm/companies/${req.gap.company_id}/qualify`, { ...f, contact_id: req.gap.contact?.id || null, opportunity_id: req.opportunityId || null });
      toast.success("Cliente qualificato"); close(true);
    } catch (e) { toast.error(errorMessage(e)); }
    setBusy(false);
  };
  const valid = f.name?.trim().length >= 2 && FIELDS.every(([k]) => (f[k] || "").trim()) && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email || "");
  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && close(false)}>
      <DialogContent className="sm:max-w-md" data-testid="qualify-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Qualifica cliente</DialogTitle>
          <DialogDescription>Per passare all'offerta il cliente deve essere qualificato: ragione sociale e referente completo. Il cliente passa a "Prospect".</DialogDescription></DialogHeader>
        <div className="space-y-3 py-1">
          <div className="space-y-1.5"><Label className="text-xs">Ragione sociale *</Label><Input value={f.name || ""} maxLength={200} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="qualify-name" /></div>
          <div className="grid grid-cols-2 gap-3">{FIELDS.map(([k, l]) => (
            <div key={k} className={`space-y-1.5 ${k === "email" ? "col-span-2" : ""}`}><Label className="text-xs">{l} *</Label>
              <Input value={f[k] || ""} type={k === "email" ? "email" : "text"} maxLength={k === "email" ? 254 : 80} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`qualify-${k}`} /></div>))}
          </div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => close(false)}>Annulla</Button>
          <Button onClick={save} disabled={busy || !valid} data-testid="qualify-save">Qualifica e continua</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
